import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { formatRP } from "../../../Utils/externalFunctions";
import { convertRPInputToIntValue } from "../../../Utils/otherFunctions";
import useAxios from "../../../Utils/useAxios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Edit } from "react-feather";
import { InputField } from "../../../CommonElements";
import updateRencImp from "../services/updateRencImp";

function ModalEdit(args) {
  const { selectedRencimp, getRencanaImp } = args;
  const axiosInstance = useAxios();
  const [modal, setModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [formattedSisa, setFormattedSisa] = useState("");
  const toggle = () => setModal(!modal);

  useEffect(() => {
    setFormData(selectedRencimp);
    updateFormattedSisa(selectedRencimp.anggaran_tersisa);
  }, [modal]);
  const updateFormattedSisa = () => {
    setFormattedSisa(
      formatRP(convertRPInputToIntValue(formData.anggaran_tersisa))
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "anggaran_tersisa") {
      const numericValue = convertRPInputToIntValue(value);
      setFormData((prev) => ({
        ...prev,
        anggaran_tersisa: numericValue,
      }));
      setFormattedSisa(formatRP(numericValue));
    }
  };

  const handleSubmit = async (pk) => {
    updateRencImp(axiosInstance, pk, formData).then(() => {
      getRencanaImp();
      toggle();
    });
  };

  return (
    <div>
      <Link
        onClick={(e) => {
          e.preventDefault();
          toggle();
        }}
      >
        <Edit color="orange" />
      </Link>
      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle}>PK: {formData.pk}</ModalHeader>
        <ModalBody>
          <InputField
            label={"Sisa Anggaran"}
            name={"anggaran_tersisa"}
            value={formatRP(convertRPInputToIntValue(formattedSisa))}
            onChange={handleChange}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleSubmit(formData.pk)}>
            Submit
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ModalEdit;
